import type { Board } from '@atlassian/jira-navigation-types/src/types.tsx';

export type BoardsPage = {
	total: number;
	values: Board[];
};

export type SearchResults = {
	inLocation: BoardsPage;
	notInLocation: BoardsPage;
};

export type AccountId = string;
export const toAccountId = (value: string): AccountId => value;

export type OnBoardClick = (board: Board, isInLocation: boolean) => Promise<void>;
export type OnNavigateUrl = (url: string) => void;

export const ProjectLocation = 'ProjectLocation' as const;
export const UserAccountLocation = 'UserAccountLocation' as const;
export type LocationType = typeof ProjectLocation | typeof UserAccountLocation;
